import { Text } from '@react-pdf/renderer'
import { parseDocument } from 'htmlparser2'
import React from 'react'

import H1 from '../components/typography/H1'
import H2 from '../components/typography/H2'
import H3 from '../components/typography/H3'
import List from '../components/typography/List'
import ListItem from '../components/typography/ListItem'
import Paragraph from '../components/typography/Paragraph'
import StrikeThrough from '../components/typography/StrikeThrough'
import { TGeneric } from '../types'

export const parseHtml = (_html: string): React.ReactNode => {
	const doc = parseDocument(_html)
	const rootNodes = doc.children

	const transformNode = (_node: TGeneric, index: number): React.ReactNode | null => {
		if (_node.type === 'text') {
			const data = (_node as TGeneric).data
			return <Text key={`text-${index}`}>{data}</Text>
		}

		if (_node.type === 'tag') {
			const el = _node as TGeneric
			const children = el.children
				.map(transformNode)
				.map((child: TGeneric, i: number) => (
					<React.Fragment key={`child-${i}`}>{child}</React.Fragment>
				))

			switch (el.name) {
				case 'h1':
					return <H1 key={`h1-${index}`}>{children}</H1>
				case 'h2':
					return <H2 key={`h2-${index}`}>{children}</H2>
				case 'h3':
					return <H3 key={`h3-${index}`}>{children}</H3>
				case 'p':
					return <Paragraph key={`p-${index}`}>{children}</Paragraph>
				case 'strong':
					return (
						<Paragraph key={`strong-${index}`} strong>
							{children}
						</Paragraph>
					)
				case 's':
					return <StrikeThrough key={`s-${index}`}>{children}</StrikeThrough>
				case 'ul':
				case 'ol':
					return <List key={`list-${index}`}>{children}</List>
				case 'li':
					return <ListItem key={`li-${index}`}>{children}</ListItem>
				default:
					return <Text key={`default-${index}`}>{children}</Text>
			}
		}

		return null
	}

	return rootNodes.map((node, index) => transformNode(node, index))
}
